import React from 'react';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';

const TabContainer = (props) => {
  const styles = {
    tabs: {
      verticalAlign: 'top',
    },
    links: {
      margin: 0,
      marginTop: '10px',
      marginBottom: '10px',
      padding: 0,
      borderBottom: '1px solid #ddd',
    },
    tabLink: {
      height: '30px',
      lineHeight: '30px',
      paddingBottom: '5px',
      marginRight: '18px',
      cursor: 'pointer',
      borderBottom: '2px solid transparent',
      display: 'inline-block',
      outline: 0,
      color: '#89876b',
      fontSize: '12px',
    },
    activeLinkStyle: {
      color: '#514d37',
      borderBottom: '3px solid #feee00',
      fontWeight: 'bold',
    },
    visibleTabStyle: {
    },
    content: {
    },
  };
  return (
    <Tabs
      name={props.config.name}
      selectedTab={props.config.selectedTab}
      handleSelect={props.config.handleSelect}
      activeLinkStyle={styles.activeLinkStyle}
      visibleTabStyle={styles.visibleTabStyle}
      style={styles.tabs}
    >
      <div style={styles.links}>
        {props.config.tabs.map((tab) => {
          return <TabLink key={tab.key} to={tab.key} style={styles.tabLink}>{tab.title}</TabLink>;
        })}
      </div>

      <div style={styles.content}>
        {props.config.tabs.map((tab) => {
          return <TabContent key={tab.key} for={tab.key}>{tab.content}</TabContent>;
        })}
      </div>
    </Tabs>
  );
};


export default TabContainer;



// WEBPACK FOOTER //
// ./src/components/common/tabs/index.js